import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router } from '@angular/router'
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet'
import { MatListModule } from '@angular/material/list'
import { MatDivider } from '@angular/material/divider'

import { TranslationService } from '../../../../../../services/translation.service'
import { ImportResin } from '../../../../../../types/resins'

const RESIN_VALIDATION_STATUSES = {
  VALID: 'valid',
  INVALID: 'invalid',
} as const

@Component({
  selector: 'app-resins-sheet',
  imports: [MatListModule, MatDivider, CommonModule],
  templateUrl: './resins-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './resins-sheet.component.scss',
})
export class ResinsSheetComponent {
  data = inject(MAT_BOTTOM_SHEET_DATA)
  router = inject(Router)
  translationService = inject(TranslationService)

  resins: Array<ImportResin> = []
  validationStatuses = RESIN_VALIDATION_STATUSES

  // the object injected below has to be any since 'data' is dynamic

  constructor() {
    const data = this.data

    if (data.resins) {
      this.resins = data.resins
    }
  }

  /**
   * Handles the `keydown` event for keyboard navigation.
   * Allows navigating the list using arrow keys and selecting items with Enter.
   *
   * @param {KeyboardEvent} event - The keyboard event triggered when a key is pressed down.
   * @param {number} index - The current index of the focused list item.
   */
  onKeydown(event: KeyboardEvent, index: number): void {
    // Prevent default scroll behavior
    event.preventDefault()
    const listItems = document.querySelectorAll('a[mat-list-item]')

    if (event.key === 'ArrowDown') {
      // Prevent default scroll behavior
      event.preventDefault()

      // Focus the next item, if it exists
      if (index < listItems.length - 1)
        (listItems[index + 1] as HTMLElement).focus()
    } else if (event.key === 'ArrowUp') {
      // Prevent default scroll behavior
      event.preventDefault()

      // If the current index is greater than 0, focus on the previous item
      if (index > 0) (listItems[index - 1] as HTMLElement).focus()
    }
  }
}
